import { defineStore } from "pinia";

import API from "../api/index.js";


export const useClassesStore = defineStore("classes", {

    state: () => ({

       classes: []

    }),
    

    actions: {

      async fetch_classes() {

        const response = await API.fetch_classes(); // Axios interceptor handles errors

        this.classes = response.all_classes || []

        console.log(this.classes)
      
      }
   }
})